import { MenuOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import { FC } from 'react'
import PrintQueueEntry from '../../../../../../../../types/api/print-queue-entry'
import GroupOperationsDropdown from './group-operations-dropdown'

interface RowSelectionColumnTitleProps {
    selected: PrintQueueEntry[]
}

const RowSelectionColumnTitle: FC<RowSelectionColumnTitleProps> = ({ selected }) => {
    const hasSelected = selected.length > 0

    return hasSelected ? (
        <GroupOperationsDropdown selected={selected} />
    ) : (
        <Tooltip title={'Групповые операции, выберите строки'}>
            <Button size={'small'} icon={<MenuOutlined />} />
        </Tooltip>
    )
}

export default RowSelectionColumnTitle
